var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { numberFormat } from '../../../utils/util';
var ProductDetailSide = function (_a) {
    var minishop = _a.minishop;
    return (React.createElement(Style, null,
        React.createElement("colgroup", null,
            React.createElement("col", null),
            React.createElement("col", null)),
        React.createElement("thead", null),
        React.createElement("tbody", null,
            React.createElement("tr", null,
                React.createElement("th", null, "\uBC30\uC1A1\uC815\uBCF4"),
                React.createElement("td", null,
                    React.createElement("p", null, minishop.cost_deliv === 0 ? '무료배송' : "".concat(numberFormat(minishop.cost_deliv), "\uC6D0")),
                    React.createElement("p", null,
                        React.createElement("span", { className: "blue" }, minishop.due_unit_str.str),
                        " ",
                        minishop.name_deliv,
                        " \uBC1C\uC1A1 \uC608\uC815"))))));
};
var Style = styled.table(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin: 0 0 20px;\n    width: 100%;\n    font-size: 14px;\n    color: #555;\n\n    .blue {\n        color: #418ded\n    }\n    th, td {\n        vertical-align: top;\n        padding: 12px 0;\n        border-bottom: 1px solid #e5e5e5;\n    }\n    th {\n        font-weight: 400;\n        text-align: left;\n    }\n    td {\n        p {\n            &:not(&:first-child) {\n                margin: 4px 0 0;\n            }\n        }\n    }\n"], ["\n    margin: 0 0 20px;\n    width: 100%;\n    font-size: 14px;\n    color: #555;\n\n    .blue {\n        color: #418ded\n    }\n    th, td {\n        vertical-align: top;\n        padding: 12px 0;\n        border-bottom: 1px solid #e5e5e5;\n    }\n    th {\n        font-weight: 400;\n        text-align: left;\n    }\n    td {\n        p {\n            &:not(&:first-child) {\n                margin: 4px 0 0;\n            }\n        }\n    }\n"])));
export default ProductDetailSide;
var templateObject_1;



//////////////////
// WEBPACK FOOTER
// ./src/detail/components/summary_info/detail/product_side.tsx
// module id = 210
// module chunks = 0